import {
  BorderLinearProgress, ProgressBarContainer, ProgressBarRow, ProgressText, StyledTitle
} from "./MoaDashboard.styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { FC } from "react";

interface EventProgressBarProps {
  name: string;
  processed: number;
  total: number;
}

const EventProgressBar: FC<EventProgressBarProps> = (
    {
      name,
      processed,
      total
    }
) => {
  const muiTheme = createTheme();

  return (
      <ProgressBarContainer>
        <StyledTitle>Processing {name}</StyledTitle>
        <ProgressBarRow>
          <ProgressText
              style={{
                position: 'absolute',
                top: '4px',
                left: '15px'
              }}
          >
            {processed}
          </ProgressText>
          <ThemeProvider theme={muiTheme} key={'time-picker-mui-theme'}>
            <BorderLinearProgress
                variant="determinate"
                value={processed / total * 100}
                data-testid={`progressBar-${name}`}
            />
          </ThemeProvider>
          <ProgressText
              style={{
                paddingTop: '4px',
                paddingLeft: '5px'
              }}
          >
            {total}
          </ProgressText>
        </ProgressBarRow>
      </ProgressBarContainer>
  )
}

export default EventProgressBar;